import React from 'react'
import BandBackButton from './BandBackButton'

interface DarkTab {
  id: string
  text: string
}

interface DarkTabsProps {
  tabs: DarkTab[]
  activeId: string
  onTabClick: (id: string) => void
  // When set, an arrow to this route is rendered at the left of the band. The
  // developer tools pass DEVELOPER_CENTER_PATH: the center is the only place
  // they are linked from now that the sidebar does not list them.
  backTo?: string
}

// 52px dark tab band matching the dashboard header / sidebar colour.
const DarkTabs: React.FC<DarkTabsProps> = ({ tabs, activeId, onTabClick, backTo }) => (
  <div
    style={{
      flexShrink: 0,
      height: '52px',
      boxSizing: 'border-box',
      display: 'flex',
      alignItems: 'stretch',
      backgroundColor: 'var(--tma-band-bg)'
    }}
  >
    {backTo && (
      <div style={{ flexShrink: 0, display: 'flex', alignItems: 'center', paddingLeft: '6px' }}>
        <BandBackButton to={backTo} />
      </div>
    )}
    {tabs.map((tab) => {
      const isActive = tab.id === activeId
      return (
        <button
          key={tab.id}
          type='button'
          onClick={() => onTabClick(tab.id)}
          aria-current={isActive ? 'page' : undefined}
          style={{
            flex: 1,
            background: 'transparent',
            border: 'none',
            // The #6c8cff underline stays literal: the band is dark in both modes.
            borderBottom: isActive ? '3px solid #6c8cff' : '3px solid transparent',
            color: isActive ? 'var(--tma-band-text)' : 'var(--tma-band-text-muted)',
            fontFamily: "'F-Default', Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
            fontSize: '14px',
            fontWeight: isActive ? 600 : 500,
            cursor: 'pointer',
            transition: 'color 0.15s ease, border-color 0.15s ease'
          }}
        >
          {tab.text}
        </button>
      )
    })}
  </div>
)

export default DarkTabs
